/**
 * Hoe een klant op het scherm en op papier heet.
 *
 * Bij een zakelijke bestelling is het BEDRIJF de klant; de persoon is degene die de bestelling
 * plaatste. De klantfactuur deed dat goed, maar de admin-lijsten en de bestelbon naar Timmers
 * toonden alleen de persoon. Bij order 1066 stond er "Bulut" terwijl de order van De Wolk glas
 * B.V. was — op de bon die met de chauffeur meegaat is dat de verkeerde naam om naar te vragen.
 * (Gemeld 03-10-2026.)
 *
 * Eén plek voor deze keuze, zodat lijst, orderscherm en bestelbon niet uiteenlopen.
 */
export interface KlantNaamVelden {
  firstName?: string;
  lastName?: string;
  companyName?: string;
  email?: string;
}

/** De persoon die bestelde. Zonder naam valt het terug op het e-mailadres. */
export function persoonNaam(c: KlantNaamVelden | null | undefined): string {
  return [c?.firstName, c?.lastName].map((x) => x?.trim()).filter(Boolean).join(" ") || (c?.email?.trim() ?? "");
}

/** De bedrijfsnaam, of leeg bij een particulier. */
export function bedrijfNaam(c: KlantNaamVelden | null | undefined): string {
  return c?.companyName?.trim() ?? "";
}

/**
 * Eén regel voor lijsten en overzichten: "De Wolk glas B.V. · Özver Bulut", of alleen de persoon
 * bij een particulier. Het bedrijf staat vooraan, want daarop wordt gezocht en herkend.
 */
export function klantLabel(c: KlantNaamVelden | null | undefined): string {
  const bedrijf = bedrijfNaam(c);
  const persoon = persoonNaam(c);
  if (!bedrijf) return persoon;
  return persoon && persoon !== bedrijf ? `${bedrijf} · ${persoon}` : bedrijf;
}

/**
 * De referentie op de bestelbon: waar Timmers en de chauffeur de order aan herkennen. Bij een
 * bedrijf is dat de bedrijfsnaam; die staat ook op het pand en op de bel.
 */
export function klantReferentie(c: KlantNaamVelden | null | undefined): string {
  return bedrijfNaam(c) || c?.lastName?.trim() || persoonNaam(c) || "—";
}
